import type { Locale } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute, NoPathParams } from "../api"
import type { DealershipListView, SortOptions } from "./index"

export interface GetDealershipListViewBody {
	filter?: {
		marketplace?: string
		organisationFunctions?: string[]
		searchText?: string
	}
	paging: {
		limit: number
		offset: number
	}
	sort: SortOptions
}
export interface GetDealershipListViewQueryParams {
	locale: Locale
}

export type GetDealershipListViewDto = DealershipListView

export const getDealershipListViewRoute: ApiRoute<
	NoPathParams,
	GetDealershipListViewQueryParams,
	GetDealershipListViewBody,
	GetDealershipListViewDto
> = {
	buildUrl: () => "/dealerships",
	method: "post",
	path: "/dealerships",
}
